module.exports = __webpack_public_path__ + "static/media/BM_ManageUsers.ba2a426e.svg";